import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const userInitSelector = (state: State) =>
  state.userInit.entities?.enums;
export const userInitStatusSelector = (state: State) => state.userInit.status;

export const userInitLoadedSelector = isLoaded(userInitStatusSelector);
export const userInitRejectedSelector = isRejected(userInitStatusSelector);
export const userInitPendingSelector = isPending(userInitStatusSelector);
export const shouldLoadUsersSelector = shouldLoad(userInitStatusSelector);
